import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {environment} from './environments/environment';
import {initializeAppCheck, ReCaptchaEnterpriseProvider} from 'firebase/app-check';
import {initializeApp} from 'firebase/app';

if (environment.production) {
	enableProdMode();
}

// Initialize Firebase for App Check (client-side only)
if (typeof window !== 'undefined') {
	const firebaseApp = initializeApp(environment.firebase);

	// Initialisation App Check (skip localhost for local perf/debug)
	if (environment.production) {
		const hostname = window.location.hostname;
		const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
		if (!isLocalhost) {
			initializeAppCheck(firebaseApp, {
				provider: new ReCaptchaEnterpriseProvider(environment.captcha),
				isTokenAutoRefreshEnabled: true
			});
		}
	}
}

bootstrapApplication(AppComponent, appConfig).catch(console.error);
